import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

/**
 * Traverses a Kendo CompositeFilterDescriptor recursively to find all unique field names.
 * 
 * @param descriptor The root filter descriptor to search.
 * @returns An array of unique field strings.
 */
export function getDistinctFilterFields(descriptor: CompositeFilterDescriptor | FilterDescriptor): string[] {
	const fields = new Set<string>();

	const walk = (item: CompositeFilterDescriptor | FilterDescriptor) => {
		if (!item) return;

		//
		// If it has a filters array, it's a Composite (Group)
		//
		if ('filters' in item && Array.isArray(item.filters)) {
			item.filters.forEach(walk);
		}

		//
		// Else, if it has a field property, it's a Leaf (Descriptor)
		//
		else if ('field' in item) {
			const fieldName = item.field;
			if (typeof fieldName === 'string') {
				fields.add(fieldName);
			}
		}
	};

	walk(descriptor);

	return Array.from(fields).sort();
}